import dhtmlXGridObject from './dhtmlXGridObject';
import {dhx4} from '../../global/dhx4OrDhx';
import dhtmlx from '../../global/dhtmlx';
import {_isFF} from '../../global/commonUtils';
import dhtmlxArray from './dhtmlxArray';
import {dhtmlXGridComboObject,Hashtable,globalObj} from './dxGridComClass';
import eXcell_tree from '../gridXCell/eXcell_tree';

dhtmlXGridObject.prototype.getRowAttribute = function (c, a) {
    return this.getRowById(c)._attrs[a];
};
dhtmlXGridObject.prototype.setRowAttribute = function (e, a, c) {
    this.getRowById(e)._attrs[a] = c;
};
dhtmlXGridObject.prototype.isTreeGrid = function () {
    return this.cellType._dhx_find("tree") != -1;
};
dhtmlXGridObject.prototype.setRowHidden = function (l, e) {
    // var c = dhx4.s2b(e);
    var h = this.getRowById(l);
    if (!h) {
        return;
    }
    if (h.expand === "") {
        this.collapseKids(h);
    }
    if (e && h.style.display != "none") {
        h.style.display = "none";
        var g = this.selectedRows._dhx_find(h);
        if (g != -1) {
            h.className = h.className.replace("rowselected", "");
            for (var a = 0; a < h.childNodes.length; a++) {
                h.childNodes[a].className = h.childNodes[a].className.replace(/cellselected/g, "");
            }
            this.selectedRows._dhx_removeAt(g);
        }
        this.callEvent("onGridReconstructed", []);
    }
    if (!e && h.style.display == "none") {
        h.style.display = "";
        this.callEvent("onGridReconstructed", []);
    }
    this.callEvent("onRowHide", [l, e]);
    this.setSizes();
};
dhtmlXGridObject.prototype.setColumnHidden = function (e, c) {
    if (!this.hdr.rows.length) {
        if (!this._ivizcol) {
            this._ivizcol = [];
        }
        return (this._ivizcol[e] = c);
    }
    if (this.fldSorted && this.fldSorted.cellIndex == e && c) {
        this.sortImg.style.display = "none";
    }
    var a = dhx4.s2b(c);
    if (a) {
        if (!this._hrrar) {
            this._hrrar = new Array();
        }
        else {
            if (this._hrrar[e]) {
                return;
            }
        }
        this._hrrar[e] = "display:none;";
        this._hideShowColumn(e, "none");
    }
    else {
        if (!this._hrrar || !this._hrrar[e]) {
            return;
        }
        this._hrrar[e] = "";
        this._hideShowColumn(e, "");
    }
    if (this.fldSorted && this.fldSorted.cellIndex == e && !c) {
        this.sortImg.style.display = "inline";
    }
    this.setSortImgPos();
    this.callEvent("onColumnHidden", [e, c]);
};
dhtmlXGridObject.prototype.isColumnHidden = function (a) {
    if (this._hrrar && this._hrrar[a]) {
        return true;
    }
    return false;
};
dhtmlXGridObject.prototype.setColumnsVisibility = function (c) {
    if (c) {
        this._ivizcol = c.split(this.delim);
    }
    if (this.hdr.rows.length && this._ivizcol) {
        for (var a = 0; a < this._ivizcol.length; a++) {
            this.setColumnHidden(a, this._ivizcol[a]);
        }
    }
};
dhtmlXGridObject.prototype._fixHiddenRowsAll = function (n, e, a, c, l) {
    l = l || "_cellIndex";
    var m = n.rows.length;
    for (var h = 0; h < m; h++) {
        var o = n.rows[h].childNodes;
        if (o.length != this._cCount) {
            for (var g = 0; g < o.length; g++) {
                if (o[g][l] == e) {
                    o[g].style[a] = c;
                    break;
                }
            }
        }
        else {
            o[e].style[a] = c;
        }
    }
};
dhtmlXGridObject.prototype._hideShowColumn = function (h, g) {
    // var a = h;
    var c = null;
    if (this.hdr.rows[1] &&
        this.hdr.rows[1]._childIndexes &&
        this.hdr.rows[1]._childIndexes[h] != h) {
        // a = this.hdr.rows[1]._childIndexes[h];
    }
    if (g == "none") {
        this.hdr.rows[0].cells[h]._oldWidth =
            this.hdr.rows[0].cells[h].style.width || this.initCellWidth[h] + "px";
        this.hdr.rows[0].cells[h]._oldWidthP = this.cellWidthPC[h];
        this.obj.rows[0].cells[h].style.width = "0px";
        c = { rows: [this.obj.rows[0]] };
        this.forEachRow(function (l) {

            if (this.rowsAr[l].tagName == "TR") {

                c.rows.push(this.rowsAr[l]);
            }
        });
        this._fixHiddenRowsAll(c, h, "display", "none");
        if (this.isTreeGrid()) {
            this._fixHiddenRowsAllTG(h, "none");
        }
        if ((dhx4.isOpera && window._OperaRv < 9) ||
            window._isKHTML ||
            _isFF) {
            this._fixHiddenRowsAll(this.hdr, h, "display", "none", "_cellIndexS");
        }
        if (this.ftr) {
            this._fixHiddenRowsAll(this.ftr.childNodes[0], h, "display", "none");
        }
        this._fixHiddenRowsAll(this.hdr, h, "whiteSpace", "nowrap", "_cellIndexS");
        if (!this.cellWidthPX.length && !this.cellWidthPC.length) {
            this.cellWidthPX = [].concat(this.initCellWidth);
        }
        if (this.cellWidthPX[h]) {
            this.cellWidthPX[h] = 0;
        }
        if (this.cellWidthPC[h]) {
            this.cellWidthPC[h] = 0;
        }
    }
    else {
        if (this.hdr.rows[0].cells[h]._oldWidth) {
            var e = this.hdr.rows[0].cells[h];
            if (dhx4.isOpera || window._isKHTML || _isFF) {
                this._fixHiddenRowsAll(this.hdr, h, "display", "", "_cellIndexS");
            }
            if (this.ftr) {
                this._fixHiddenRowsAll(this.ftr.childNodes[0], h, "display", "");
            }
            c = { rows: [this.obj.rows[0]] };
            this.forEachRow(function (l) {

                if (this.rowsAr[l].tagName == "TR") {

                    c.rows.push(this.rowsAr[l]);
                }
            });
            this._fixHiddenRowsAll(c, h, "display", "");
            if (this.isTreeGrid()) {
                this._fixHiddenRowsAllTG(h, "");
            }
            this._fixHiddenRowsAll(this.hdr, h, "whiteSpace", "normal", "_cellIndexS");
            if (e._oldWidthP) {
                this.cellWidthPC[h] = e._oldWidthP;
            }
            if (e._oldWidth) {
                this.cellWidthPX[h] = parseInt(e._oldWidth);
            }
        }
    }
    if (!g && this._realfake) {
        this.setColumnSizes(this.entBox.clientWidth);
    }
    this.setSizes();
    if (!dhx4.isIE && !_isFF) {
        this.obj.border = 1;
        this.obj.border = 0;
    }
};
dhtmlXGridObject.prototype.enableColSpan = function (a) {
    this._ecspn = dhx4.s2b(a);
};
dhtmlXGridObject.prototype.enableRowsHover = function (c, a) {
    this._unsetRowHover(false, true);
    this._hvrCss = a;
    if (dhx4.s2b(c)) {
        if (!this._elmnh) {
            this.obj._honmousemove = this.obj.onmousemove;
            this.obj.onmousemove = this._setRowHover;
            if (dhx4.isIE) {
                this.obj.onmouseleave = this._unsetRowHover;
            }
            else {
                this.obj.onmouseout = this._unsetRowHover;
            }
            this._elmnh = true;
        }
    }
    else {
        if (this._elmnh) {
            this.obj.onmousemove = this.obj._honmousemove;
            if (dhx4.isIE) {
                this.obj.onmouseleave = null;
            }
            else {
                this.obj.onmouseout = null;
            }
            this._elmnh = false;
        }
    }
};
dhtmlXGridObject.prototype.enableEditEvents = function (c, e, a) {
    this._sclE = dhx4.s2b(c);
    this._dclE = dhx4.s2b(e);
    this._f2kE = dhx4.s2b(a);
};
dhtmlXGridObject.prototype.enableLightMouseNavigation = function (a) {
    if (dhx4.s2b(a)) {
        if (!this._elmn) {
            this.entBox._onclick = this.entBox.onclick;
            this.entBox.onclick = function () {
                return true;
            };
            this.obj._onclick = this.obj.onclick;
            this.obj.onclick = function (g) {
                var h = this.grid.getFirstParentOfType(g ? g.target : event.srcElement, "TD");
                if (!h) {
                    return;
                }
                this.grid.editStop();
                this.grid.doClick(h);
                this.grid.editCell();
                (g || event).cancelBubble = true;
            };
            this.obj._onmousemove = this.obj.onmousemove;
            this.obj.onmousemove = this._autoMoveSelect;
            this._elmn = true;
        }
    }
    else {
        if (this._elmn) {
            this.entBox.onclick = this.entBox._onclick;
            this.obj.onclick = this.obj._onclick;
            this.obj.onmousemove = this.obj._onmousemove;
            this._elmn = false;
        }
    }
};
dhtmlXGridObject.prototype._unsetRowHover = function (g, h) {
    var that = null;
    if (h) {
        that = this;
    }
    else {
        that = this.grid;
    }
    if (that._lahRw && that._lahRw != h) {
        for (var a = 0; a < that._lahRw.childNodes.length; a++) {
            that._lahRw.childNodes[a].className = that._lahRw.childNodes[a].className.replace(that._hvrCss, "");
        }
        that._lahRw = null;
    }
};
dhtmlXGridObject.prototype._setRowHover = function (g) {
    var h = this.grid.getFirstParentOfType(g ? g.target : event.srcElement, "TD");
    if (h && h.parentNode != this.grid._lahRw) {
        this.grid._unsetRowHover(0, h);
        h = h.parentNode;
        if (!h.idd || h.idd == "__filler__") {
            return;
        }
        for (var a = 0; a < h.childNodes.length; a++) {
            h.childNodes[a].className += " " + this.grid._hvrCss;
        }
        this.grid._lahRw = h;
    }
    this._honmousemove(g);
};
dhtmlXGridObject.prototype._autoMoveSelect = function (a) {
    if (!this.grid.editor) {
        var g = this.grid.getFirstParentOfType(a ? a.target : event.srcElement, "TD");
        if (g.parentNode.idd) {
            this.grid.doClick(g, true, 0);
        }
    }
    this._onmousemove(a);
};
dhtmlXGridObject.prototype.enableDistributedParsing = function (e, a, c) {
    if (dhx4.s2b(e)) {
        this._ads_count = a || 10;
        this._ads_time = c || 250;
    }
    else {
        this._ads_count = 0;
    }
};
dhtmlXGridObject.prototype.destructor = function () {
    this.editStop(true);
    if (this._sizeTime) {
        this._sizeTime = window.clearTimeout(this._sizeTime);
    }
    this.entBox.className = (this.entBox.className || "").replace(/gridbox.*/, "");
    if (this.formInputs) {
        for (var e = 0; e < this.formInputs.length; e++) {
            this.parentForm.removeChild(this.formInputs[e]);
        }
    }
    var c;
    for (var e_1 = 0; e_1 < this.rowsCol.length; e_1++) {
        if (this.rowsCol[e_1]) {
            this.rowsCol[e_1].grid = null;
        }
    }
    for (var e_2 in this.rowsAr) {
        if (this.rowsAr[e_2]) {
            this.rowsAr[e_2] = null;
        }
    }
    this.rowsCol = new dhtmlxArray();
    this.rowsAr = {};
    this.entBox.innerHTML = "";
    var g = function () { };
    this.entBox.onclick = this.entBox.onmousedown = this.entBox.onbeforeactivate = this.entBox.onbeforedeactivate = this.entBox.onbeforedeactivate = this.entBox.onselectstart = g;
    this.setSizes = this._update_srnd_view = this.callEvent = g;
    this.entBox.grid = this.objBox.grid = this.hdrBox.grid = this.obj.grid = this.hdr.grid = null;
    if (this._fake) {
        this.globalBox.innerHTML = "";
        this._fake.setSizes = this._fake._update_srnd_view = this._fake.callEvent = g;
        this.globalBox.onclick = this.globalBox.onmousedown = this.globalBox.onbeforeactivate = this.globalBox.onbeforedeactivate = this.globalBox.onbeforedeactivate = this.globalBox.onselectstart = g;
    }
    for (c in this) {
        if (this[c] && this[c].m_obj) {
            this[c].m_obj = null;
        }
        this[c] = null;
    }

    if (this == globalObj.globalActiveDHTMLGridObject) {
        globalObj.globalActiveDHTMLGridObject = null;
    }
    return null;
};
dhtmlXGridObject.prototype.getSortingState = function () {
    var a = new Array();
    if (this.fldSorted) {
        a[0] = this.fldSorted._cellIndex;
        a[1] = this.sortImg.className.indexOf("dhxgrid_sort_desc")>0? "des" : "asc";
    }
    return a;
};
dhtmlXGridObject.prototype.enableAutoHeight = function (e, c, a) {
    this._ahgr = dhx4.s2b(e);
    this._ahgrF = dhx4.s2b(a);
    this._ahgrM = c || null;
    if (arguments.length == 1) {
        this.objBox.style.overflowY = e ? "hidden" : "auto";
    }
    if (c == "auto") {
        this._ahgrM = null;
        this._ahgrMA = true;
        this._setAutoResize();
    }
};
dhtmlXGridObject.prototype.enableStableSorting = function (a) {
    this._sst = dhx4.s2b(a);
    this.rowsCol.stablesort = function (l) {
        var h = this.length - 1;
        for (var g = 0; g < this.length - 1; g++) {
            for (var e = 0; e < h; e++) {
                if (l(this[e], this[e + 1]) > 0) {
                    var c = this[e];
                    this[e] = this[e + 1];
                    this[e + 1] = c;
                }
            }
            h--;
        }
    };
};
dhtmlXGridObject.prototype.enableKeyboardSupport = function (a) {
    this._htkebl = !dhx4.s2b(a);
};
dhtmlXGridObject.prototype.enableContextMenu = function (a) {
    this._ctmndx = a;
};
dhtmlXGridObject.prototype.setScrollbarWidthCorrection = function () { };
dhtmlXGridObject.prototype.enableTooltips = function (c) {
    this._enbTts = c.split(",");
    for (var a = 0; a < this._enbTts.length; a++) {
        this._enbTts[a] = dhx4.s2b(this._enbTts[a]);
    }
};
dhtmlXGridObject.prototype.enableResizing = function (c) {
    this._drsclmn = c.split(",");
    for (var a = 0; a < this._drsclmn.length; a++) {
        this._drsclmn[a] = dhx4.s2b(this._drsclmn[a]);
    }
};
dhtmlXGridObject.prototype.setColumnMinWidth = function (a, c) {
    if (arguments.length == 2) {
        if (!this._drsclmW) {
            this._drsclmW = new Array();
        }
        this._drsclmW[c] = a;
    }
    else {
        this._drsclmW = a.split(",");
    }
};
dhtmlXGridObject.prototype.enableCellIds = function (a) {
    this._enbCid = dhx4.s2b(a);
};
dhtmlXGridObject.prototype.lockRow = function (a, e) {
    var c = this.getRowById(a);
    if (c) {
        c._locked = dhx4.s2b(e);
        if (this.cell && this.cell.parentNode.idd == a) {
            this.editStop();
        }
    }
};
dhtmlXGridObject.prototype._getRowArray = function (h) {
    var g = new Array();
    for (var e = 0; e < h.childNodes.length; e++) {
        var c = this.cells3(h, e);
        g[e] = c.getValue();
    }
    return g;
};
dhtmlXGridObject.prototype.setDateFormat = function (c, a) {
    this._dtmask = c;
    this._dtmask_inc = a;
};
dhtmlXGridObject.prototype.setNumberFormat = function (n, e, h, m) {
    var g = n.replace(/[^0\,\.]*/g, "");
    var a = g.indexOf(".");
    if (a > -1) {
        a = g.length - a - 1;
    }
    var c = g.indexOf(",");
    if (c > -1) {
        c = g.length - a - 2 - c;
    }
    if (typeof h != "string") {
        h = this.i18n.decimal_separator;
    }
    if (typeof m != "string") {
        m = this.i18n.group_separator;
    }
    var o = n.split(g)[0];
    var l = n.split(g)[1];
    this._maskArr[e] = [a, c, o, l, h, m];
};
dhtmlXGridObject.prototype._aplNFb = function (h, g) {
    var c = this._maskArr[g];
    if (!c) {
        return h;
    }
    var e = parseFloat(h.toString().replace(/[^0-9]*/g, ""));
    if (h.toString().substr(0, 1) == "-") {
        e = e * -1;
    }
    if (c[0] > 0) {
        e = e / Math.pow(10, c[0]);
    }
    return e;
};
dhtmlXGridObject.prototype._aplNF = function (l, h) {
    var e = this._maskArr[h];
    if (!e) {
        return l;
    }
    var m = (parseFloat(l) < 0 ? "-" : "") + e[2];
    l = Math.abs(Math.round(parseFloat(l) * Math.pow(10, e[0] > 0 ? e[0] : 0))).toString();
    l = (l.length < e[0]
        ? Math.pow(10, e[0] + 1 - l.length)
            .toString()
            .substr(1, e[0] + 1) + l.toString()
        : l)
        .split("")
        .reverse();
    l[e[0]] = (l[e[0]] || "0") + e[4];
    if (e[1] > 0) {
        for (var g = (e[0] > 0 ? 0 : 1) + e[0] + e[1]; g < l.length; g += e[1]) {
            l[g] += e[5];
        }
    }
    return m + l.reverse().join("") + e[3];
};
dhtmlXGridObject.prototype._launchCommands = function (a) {
    for (var g = 0; g < a.length; g++) {
        var e = new Array();
        for (var c = 0; c < a[g].childNodes.length; c++) {
            if (a[g].childNodes[c].nodeType == 1) {
                e[e.length] = a[g].childNodes[c].firstChild.data;
            }
        }
        this[a[g].getAttribute("command")].apply(this, e);
    }
};
dhtmlXGridObject.prototype._parseHead = function (h) {
    var g = dhx4.ajax.xpath("./head", h);
    if (g.length) {
        var l = dhx4.ajax.xpath("./column", g[0]);
        var m = dhx4.ajax.xpath("./settings", g[0]);
        var C = "setInitWidths";
        var w = false;
        if (m[0]) {
            for (var n = 0; n < m[0].childNodes.length; n++) {
                switch (m[0].childNodes[n].tagName) {
                    case "colwidth":
                        if (m[0].childNodes[n].firstChild &&
                            m[0].childNodes[n].firstChild.data == "%") {
                            C = "setInitWidthsP";
                        }
                        break;
                    case "splitat":
                        w = m[0].childNodes[n].firstChild
                            ? m[0].childNodes[n].firstChild.data
                            : false;
                        break;
                }
            }
        }
        this._launchCommands(dhx4.ajax.xpath("./beforeInit/call", g[0]));
        if (l.length > 0) {
            if (this.hdr.rows.length > 0) {
                this.clearAll(true);
            }
            var a = [[], [], [], [], [], [], [], [], []];
            var v = [
                "",
                "width",
                "type",
                "align",
                "sort",
                "color",
                "format",
                "hidden",
                "id"
            ];
            var u = [
                "",
                C,
                "setColTypes",
                "setColAlign",
                "setColSorting",
                "setColumnColor",
                "",
                "",
                "setColumnIds"
            ];
            for (var A = 0; A < l.length; A++) {
                for (var y = 1; y < v.length; y++) {

                    a[y].push(l[A].getAttribute(v[y]));
                }

                a[0].push((l[A].firstChild ? l[A].firstChild.data : "").replace(/^\s*((\s\S)*.+)\s*$/gi, "$1"));
            }
            this.setHeader(a[0]);
            for (var A_1 = 0; A_1 < u.length; A_1++) {
                if (u[A_1]) {
                    this[u[A_1]](a[A_1].join(this.delim));
                }
            }
            for (var A_2 = 0; A_2 < l.length; A_2++) {
                if (this.cellType[A_2].indexOf("co") == 0 ||
                    this.cellType[A_2] == "clist") {
                    var o = dhx4.ajax.xpath("./option", l[A_2]);
                    if (o.length) {
                        var x = new Array();
                        if (this.cellType[A_2] == "clist") {
                            for (var y_1 = 0; y_1 < o.length; y_1++) {
                                x[x.length] = o[y_1].firstChild ? o[y_1].firstChild.data : "";
                            }
                            this.registerCList(A_2, x);
                        }
                        else {
                            var D = this.getCombo(A_2);
                            for (var y_2 = 0; y_2 < o.length; y_2++) {
                                D.put(o[y_2].getAttribute("value"), o[y_2].firstChild ? o[y_2].firstChild.data : "");
                            }
                        }
                    }
                }
                else {
                    if (a[6][A_2]) {
                        if (this.cellType[A_2].toLowerCase().indexOf("calendar") != -1 ||
                            this.fldSort[A_2] == "date") {
                            this.setDateFormat(a[6][A_2]);
                        }
                        else {
                            this.setNumberFormat(a[6][A_2], A_2);
                        }
                    }
                }
            }
            this.init();
            var e = a[7].join(this.delim);
            if (this.setColHidden && e.replace(/,/g, "") != "") {
                this.setColHidden(e);
            }
            if (w && this.splitAt) {
                this.splitAt(w);
            }
        }
        this._launchCommands(dhx4.ajax.xpath("./afterInit/call", g[0]));
    }
    var c = dhx4.ajax.xpath("//rows/userdata", h);
    if (c.length > 0) {
        if (!this.UserData.gridglobaluserdata) {
            this.UserData.gridglobaluserdata = new Hashtable();
        }
        for (var y_3 = 0; y_3 < c.length; y_3++) {
            var E = "";
            for (var r = 0; r < c[y_3].childNodes.length; r++) {
                E += c[y_3].childNodes[r].nodeValue;
            }
            this.UserData.gridglobaluserdata.put(c[y_3].getAttribute("name"), E);
        }
    }
};
dhtmlXGridObject.prototype.getCheckedRows = function (a) {
    var c = new Array();
    this.forEachRowA(function (g) {

        var e = this.cells(g, a);
        if (e.changeState && e.getValue() != 0) {
            c.push(g);
        }
    }, true);
    return c.join(",");
};
dhtmlXGridObject.prototype.checkAll = function () {
    var c = arguments.length ? arguments[0] : 1;
    for (var a = 0; a < this.getColumnsNum(); a++) {
        if (this.getColType(a) == "ch") {
            this.setCheckedRows(a, c);
        }
    }
};
dhtmlXGridObject.prototype.uncheckAll = function () {
    this.checkAll(0);
};
dhtmlXGridObject.prototype.setCheckedRows = function (c, a) {
    this.forEachRowA(function (e) {

        if (this.cells(e, c).isCheckbox()) {

            this.cells(e, c).setValue(a);
        }
    });
};
dhtmlXGridObject.prototype._drawTooltip = function (l) {
    var m = this.grid.getFirstParentOfType(l ? l.target : event.srcElement, "TD");
    if (!m || (this.grid.editor && this.grid.editor.cell == m)) {
        return true;
    }
    var h = m.parentNode;
    if (!h.idd || h.idd == "__filler__") {
        return;
    }
    var g = l ? l.target : event.srcElement;
    if (h.idd == window.unknown) {
        return true;
    }
    if (!this.grid.callEvent("onMouseOver", [
        h.idd,
        m._cellIndex,
        l || window.event
    ])) {
        return true;
    }
    if (this.grid._enbTts && !this.grid._enbTts[m._cellIndex]) {
        if (g.title) {
            g.title = "";
        }
        return true;
    }
    if (m._cellIndex >= this.grid._cCount) {
        return;
    }
    var a = this.grid.cells3(h, m._cellIndex);
    if (!a || !a.cell || !a.cell._attrs) {
        return;
    }
    if (g._title) {
        a.cell.title = "";
    }
    if (!a.cell._attrs.title) {
        g._title = true;
    }
    if (a) {
        g.title =
            a.cell._attrs.title ||
                (a.getTitle
                    ? a.getTitle()
                    : (a.getValue() || "").toString().replace(/<[^>]*>/gi, ""));
    }
    return true;
};
dhtmlXGridObject.prototype.enableCellWidthCorrection = function (a) {
    if (_isFF) {
        this._wcorr = parseInt(a);
    }
};
dhtmlXGridObject.prototype.getAllRowIds = function (e) {
    var a = [];
    for (var c = 0; c < this.rowsBuffer.length; c++) {
        if (this.rowsBuffer[c]) {
            a.push(this.rowsBuffer[c].idd);
        }
    }
    return a.join(e || this.delim);
};
dhtmlXGridObject.prototype.getAllItemIds = function () {
    return this.getAllRowIds();
};
dhtmlXGridObject.prototype.setColspan = function (e, x, g) {
    if (!this._ecspn) {
        return;
    }
    var a = this.getRowById(e);
    var o = null;
    if (a._childIndexes && a.childNodes[a._childIndexes[x]]) {
        o = a._childIndexes[x];
        var h = a.childNodes[o];
        var l = h.colSpan;
        h.colSpan = 1;
        if (l && l != 1) {
            for (var u = 1; u < l; u++) {
                var w = document.createElement("TD");
                if (h.nextSibling) {
                    a.insertBefore(w, h.nextSibling);
                }
                else {
                    a.appendChild(w);
                }
                a._childIndexes[x + u] = o + u;
                w._cellIndex = x + u;
                w.style.textAlign = this.cellAlign[u];
                w.style.verticalAlign = this.cellVAlign[u];
                h = w;
                this.cells3(a, x + u).setValue("");
            }
        }
        for (var v = x * 1 + 1 * l; v < a._childIndexes.length; v++) {
            a._childIndexes[v] += (l - 1) * 1;
        }
    }
    if (g && g > 1) {
        if (a._childIndexes) {
            o = a._childIndexes[x];
        }
        else {
            o = x;
            a._childIndexes = new Array();
            for (var v_1 = 0; v_1 < a.childNodes.length; v_1++) {
                a._childIndexes[v_1] = v_1;
            }
        }
        a.childNodes[o].colSpan = g;
        for (var v_2 = 1; v_2 < g; v_2++) {
            a._childIndexes[a.childNodes[o + 1]._cellIndex] = o;
            a.removeChild(a.childNodes[o + 1]);
        }
        var s = a.childNodes[a._childIndexes[x]]._cellIndex;
        for (var v_3 = s * 1 + 1 * g; v_3 < a._childIndexes.length; v_3++) {
            a._childIndexes[v_3] -= g - 1;
        }
    }
};
dhtmlXGridObject.prototype.enableColumnAutoSize = function (a) {
    this._eCAS = dhx4.s2b(a);
};
dhtmlXGridObject.prototype._onHeaderDblClick = function (g) {
    var c = this.grid;
    var a = c.getFirstParentOfType(dhx4.isIE ? event.srcElement : g.target, "TD");
    if (!c._eCAS) {
        return false;
    }
    c.adjustColumnSize(a._cellIndexS);
};
dhtmlXGridObject.prototype.adjustColumnSize = function (r, e) {
    if (this._hrrar && this._hrrar[r]) {
        return;
    }
    this._notresize = true;
    var g = 0;
    this._setColumnSizeR(r, 20);
    for (var n = 1; n < this.hdr.rows.length; n++) {
        var u = this.hdr.rows[n];
        u = u.childNodes[u._childIndexes ? u._childIndexes[r] : r];
        if (u && (!u.colSpan || u.colSpan < 2) && u._cellIndex == r) {
            if (u.childNodes[0] && u.childNodes[0].className == "hdrcell") {
                u = u.childNodes[0];
            }
            g = Math.max(g, u.scrollWidth);
        }
    }
    var h = this.obj.rows.length;
    var s = 0;
    var w = this.cellType._dhx_find("tree");
    for (var o = 1; o < h; o++) {
        var v = this.obj.rows[o];
        var c = r;
        if (!this.rowsAr[v.idd]) {
            continue;
        }
        if (v._childIndexes) {
            if (v._childIndexes[r] == v._childIndexes[r + 1]) {
                continue;
            }
            c = v._childIndexes[r];
        }
        if (!v.childNodes[c] || v.childNodes[c]._cellIndex != r) {
            continue;
        }
        s =
            (v.childNodes[c].innerText || v.childNodes[c].textContent || "").length *
                this.fontWidth;
        if (this._h2 && r == w) {
            s += this._h2.get[v.idd].level * 22;
        }
        if (s > g) {
            g = s;
        }
    }
    g += 20 + (e || 0);
    this._setColumnSizeR(r, g);
    this._notresize = false;
    this.setSizes();
};
dhtmlXGridObject.prototype.detachHeader = function (a, e) {
    e = e || this.hdr;
    var c = e.rows[a + 1];
    if (c) {
        c.parentNode.removeChild(c);
    }
    this.setSizes();
};
dhtmlXGridObject.prototype.detachFooter = function (a) {
    this.detachHeader(a, this.ftr);
};
dhtmlXGridObject.prototype.attachHeader = function (a, g, c) {
    if (typeof a == "string") {
        a = this._eSplit(a);
    }
    if (typeof g == "string") {
        g = g.split(this.delim);
    }
    c = c || "_aHead";
    if (this.hdr.rows.length) {
        if (a) {
            this._createHRow([a, g], this[c == "_aHead" ? "hdr" : "ftr"]);
        }
        else {
            if (this[c]) {
                for (var e = 0; e < this[c].length; e++) {
                    this.attachHeader.apply(this, this[c][e]);
                }
            }
        }
    }
    else {
        if (!this[c]) {
            this[c] = new Array();
        }
        this[c][this[c].length] = [a, g, c];
    }
};
dhtmlXGridObject.prototype._createHRow = function (e, r) {
    var m = null;
    var v = null;
    if (!r) {
        if (this.entBox.style.position != "absolute") {
            this.entBox.style.position = "relative";
        }
        m = document.createElement("DIV");
        m.className = "c_ftr".substr(2);
        this.entBox.appendChild(m);
        v = document.createElement("TABLE");
        v.cellPadding = v.cellSpacing = 0;
        if (!dhx4.isIE || dhx4.isIE == 8) {
            v.width = "100%";
            v.style.paddingRight = "20px";
        }
        v.style.marginRight = "20px";
        v.style.tableLayout = "fixed";
        m.appendChild(v);
        v.appendChild(document.createElement("TBODY"));
        this.ftr = r = v;
        var l = v.insertRow(0);
        var a = this.hdrLabels.length <= 1 ? e[0].length : this.hdrLabels.length;
        for (var g = 0; g < a; g++) {
            l.appendChild(document.createElement("TH"));
            l.childNodes[g]._cellIndex = g;
        }
        if (dhx4.isIE && dhx4.isIE < 8) {
            l.style.position = "absolute";
        }
        else {
            l.style.height = "auto";
        }
    }
    var h = e[1];
    var n = null;
    m = document.createElement("TR");
    r.rows[0].parentNode.appendChild(m);
    for (var g_1 = 0; g_1 < e[0].length; g_1++) {
        if (e[0][g_1] == "#cspan") {
            n = m.cells[m.cells.length - 1];
            n.colSpan = (n.colSpan || 1) + 1;
            continue;
        }
        if (e[0][g_1] == "#rspan" && r.rows.length > 1) {
            var y = r.rows.length - 2;
            var x = false;
            while (!x) {
                n = r.rows[y];
                for (var c = 0; c < n.cells.length; c++) {
                    if (n.cells[c]._cellIndex == g_1) {
                        x = c + 1;
                        break;
                    }
                }
                y--;
            }
            n = n.cells[x - 1];
            n.rowSpan = (n.rowSpan || 1) + 1;
            continue;
        }
        var o = document.createElement("TD");
        o._cellIndex = o._cellIndexS = g_1;
        if (this._hrrar && this._hrrar[g_1] && !dhx4.isIE) {
            o.style.display = "none";
        }
        if (typeof e[0][g_1] == "object") {
            o.appendChild(e[0][g_1]);
        }
        else {
            if (this.forceDivInHeader) {
                o.innerHTML =
                    "<div class='hdrcell'>" + (e[0][g_1] || "&nbsp;") + "</div>";
            }
            else {
                o.innerHTML = e[0][g_1] || "&nbsp;";
            }
            if ((e[0][g_1] || "").indexOf("#") != -1) {
                v = e[0][g_1].match(/(^|{)#([^}]+)(}|$)/);
                if (v) {
                    var s = "_in_header_" + v[2];
                    if (this[s]) {
                        this[s](this.forceDivInHeader ? o.firstChild : o, g_1, e[0][g_1].split(v[0]));
                    }
                }
            }
        }
        if (h) {
            o.style.cssText = h[g_1];
        }
        m.appendChild(o);
    }
    // var u = r;
    if (window._isKHTML) {
        if (r._kTimer) {
            window.clearTimeout(r._kTimer);
        }
        r._kTimer = window.setTimeout(function () {
            r.rows[1].style.display = "none";
            window.setTimeout(function () {
                r.rows[1].style.display = "";
            }, 1);
        }, 500);
    }
};
dhtmlXGridObject.prototype.attachFooter = function (a, c) {
    this.attachHeader(a, c, "_aFoot");
};
dhtmlXGridObject.prototype.setCellExcellType = function (e, a, c) {
    this.changeCellType(this.getRowById(e), a, c);
};
dhtmlXGridObject.prototype.changeCellType = function (e, g, c) {
    c = c || this.cellType[g];
    var h = this.cells3(e, g);
    var a = h.getValue();
    h.cell._cellType = c;
    h = this.cells3(e, g);
    h.setValue(a);
};
dhtmlXGridObject.prototype.setRowExcellType = function (e, c) {
    var g = this.rowsAr[e];
    for (var a = 0; a < g.childNodes.length; a++) {
        this.changeCellType(g, a, c);
    }
};
dhtmlXGridObject.prototype.setColumnExcellType = function (a, e) {
    for (var c = 0; c < this.rowsBuffer.length; c++) {
        if (this.rowsBuffer[c] && this.rowsBuffer[c].tagName == "TR") {
            this.changeCellType(this.rowsBuffer[c], a, e);
        }
    }
    if (this.cellType[a] == "math") {
        this._strangeParams[c] = e;
    }
    else {
        this.cellType[a] = e;
    }
};
dhtmlXGridObject.prototype.forEachRow = function (e) {
    for (var c in this.rowsAr) {
        if (this.rowsAr[c] && this.rowsAr[c].idd) {
            e.apply(this, [this.rowsAr[c].idd]);
        }
    }
};
dhtmlXGridObject.prototype.forEachRowA = function (e) {
    for (var c = 0; c < this.rowsBuffer.length; c++) {
        if (this.rowsBuffer[c]) {
            e.call(this, this.render_row(c).idd);
        }
    }
};
dhtmlXGridObject.prototype.forEachCell = function (e, c) {
    var g = this.getRowById(e);
    if (!g) {
        return;
    }
    for (var a = 0; a < this._cCount; a++) {
        c(this.cells3(g, a), a);
    }
};
dhtmlXGridObject.prototype.enableAutoWidth = function (e, a, c) {
    this._awdth = [dhx4.s2b(e), parseInt(a || 99999), parseInt(c || 0)];
    if (arguments.length == 1) {
        this.objBox.style.overflowX = e ? "hidden" : "auto";
    }
};
dhtmlXGridObject.prototype.updateFromXML = function (a, g, c, e) {
    if (typeof g == "undefined") {
        g = true;
    }
    this._refresh_mode = [true, g, c];
    this.load(a, e);
};
dhtmlXGridObject.prototype._refreshFromXML = function (g) {
    if (this._f_rowsBuffer) {
        this.filterBy(0, "");
    }
    var reset = false;
    if (window.eXcell_tree) {
        eXcell_tree.prototype.setValueX = eXcell_tree.prototype.setValue;
        eXcell_tree.prototype.setValue = function (v) {
            var u = this.grid._h2.get[this.cell.parentNode.idd];
            if (u && this.cell.parentNode.valTag) {
                this.setLabel(v);
            }
            else {
                this.setValueX(v);
            }
        };
    }
    var s = this.cellType._dhx_find("tree");
    var l = dhx4.ajax.xmltop("rows", g);
    var h = l.getAttribute("parent") || 0;
    var n = {};
    if (this._refresh_mode[2]) {
        if (s != -1) {
            this._h2.forEachChild(h, function (u) {
                n[u.id] = true;
            }, this);
        }
        else {
            this.forEachRow(function (u) {
                n[u] = true;
            });
        }
    }
    var r = dhx4.ajax.xpath("//row", l);
    for (var e = 0; e < r.length; e++) {
        var o = r[e];
        var a = o.getAttribute("id");
        n[a] = false;
        h = o.parentNode.getAttribute("id") || h;
        if (this.rowsAr[a] && this.rowsAr[a].tagName != "TR") {
            if (this._h2) {
                this._h2.get[a].buff.data = o;
            }
            else {
                this.rowsBuffer[this.getRowIndex(a)].data = o;
            }
            this.rowsAr[a] = o;
        }
        else {
            if (this.rowsAr[a]) {
                this._process_xml_row(this.rowsAr[a], o, -1);
                this._postRowProcessing(this.rowsAr[a], true);
                if (this._fake && this._fake.rowsAr[a]) {
                    this._fake._process_xml_row(this._fake.rowsAr[a], o, -1);
                }
            }
            else {
                if (this._refresh_mode[1]) {
                    var m = {
                        idd: a,
                        data: o,
                        _parser: this._process_xml_row,
                        _locator: this._get_xml_data
                    };
                    var c = this.rowsBuffer.length;
                    if (this._refresh_mode[1] == "top") {
                        this.rowsBuffer.unshift(m);
                        c = 0;
                    }
                    else {
                        this.rowsBuffer.push(m);
                    }
                    if (this._h2) {
                        reset = true;
                        this._h2.add(a, o.parentNode.getAttribute("id") ||
                            o.parentNode.getAttribute("parent")).buff = this.rowsBuffer[this.rowsBuffer.length - 1];
                    }
                    else {
                        if (this._srnd) {
                            reset = true;
                        }
                    }
                    this.rowsAr[a] = o;
                    o = this.render_row(c);
                    this._insertRowAt(o, c ? -1 : 0);
                }
            }
        }
    }
    if (this._refresh_mode[2]) {
        for (a in n) {
            if (n[a] && this.rowsAr[a]) {
                this.deleteRow(a);
            }
        }
    }
    this._refresh_mode = null;
    if (window.eXcell_tree) {
        eXcell_tree.prototype.setValue = eXcell_tree.prototype.setValueX;
    }
    if (reset) {
        if (this._h2) {
            this._renderSort();
        }
        else {
            this.render_dataset();
        }
    }
    if (this._f_rowsBuffer) {
        this._f_rowsBuffer = null;
        this.filterByAll();
    }
};
dhtmlXGridObject.prototype.getCustomCombo = function (e, c) {
    var a = this.cells(e, c).cell;
    if (!a._combo) {
        a._combo = new dhtmlXGridComboObject();
    }
    return a._combo;
};
dhtmlXGridObject.prototype.setTabOrder = function (c) {
    var g = c.split(this.delim);
    this._tabOrder = [];
    var a = this._cCount || c.length;
    for (var e = 0; e < a; e++) {
        g[e] = { c: parseInt(g[e]), ind: e };
    }
    g.sort(function (l, h) {
        return l.c > h.c ? 1 : -1;
    });
    for (var e_3 = 0; e_3 < a; e_3++) {
        if (!g[e_3 + 1] || typeof g[e_3].c == "undefined") {
            this._tabOrder[g[e_3].ind] = (g[0].ind + 1) * -1;
        }
        else {
            this._tabOrder[g[e_3].ind] = g[e_3 + 1].ind;
        }
    }
};
dhtmlXGridObject.prototype.i18n = {
    loading: "Loading",
    decimal_separator: ".",
    group_separator: ","
};
dhtmlXGridObject.prototype._key_events = {
    k13_1_0: function () {
        var a = this.rowsCol._dhx_find(this.row);
        this.selectCell(this.rowsCol[a + 1], this.cell._cellIndex, true);
    },
    k13_0_1: function () {
        var a = this.rowsCol._dhx_find(this.row);
        this.selectCell(this.rowsCol[a - 1], this.cell._cellIndex, true);
    },
    k13_0_0: function () {
        this.editStop();
        this.callEvent("onEnter", [
            this.row ? this.row.idd : null,
            this.cell ? this.cell._cellIndex : null
        ]);
        this._still_active = true;
    },
    k9_0_0: function () {
        this.editStop();
        if (!this.callEvent("onTab", [true])) {
            return true;
        }
        var a = this._getNextCell(null, 1);
        if (a) {
            this.selectCell(a.parentNode, a._cellIndex, this.row != a.parentNode, false, true);
            this._still_active = true;
        }
    },
    k9_0_1: function () {
        this.editStop();
        if (!this.callEvent("onTab", [false])) {
            return false;
        }
        var a = this._getNextCell(null, -1);
        if (a) {
            this.selectCell(a.parentNode, a._cellIndex, this.row != a.parentNode, false, true);
            this._still_active = true;
        }
    },
    k113_0_0: function () {
        if (this._f2kE) {
            this.editCell();
        }
    },
    k32_0_0: function () {
        var a = this.cells4(this.cell);
        if (!a.changeState || a.changeState() === false) {
            return false;
        }
    },
    k27_0_0: function () {
        this.editStop(true);
    },
    k33_0_0: function () {
        if (this.pagingOn) {
            this.changePage(this.currentPage - 1);
        }
        else {
            this.scrollPage(-1);
        }
    },
    k34_0_0: function () {
        if (this.pagingOn) {
            this.changePage(this.currentPage + 1);
        }
        else {
            this.scrollPage(1);
        }
    },
    k37_0_0: function () {
        if (!this.editor && this.isTreeGrid()) {
            this.collapseKids(this.row);
        }
        else {
            return false;
        }
    },
    k39_0_0: function () {
        if (!this.editor && this.isTreeGrid()) {
            this.expandKids(this.row);
        }
        else {
            return false;
        }
    },
    k40_0_0: function () {
        var c = this._realfake ? this._fake : this;
        if (this.editor && this.editor.combo) {
            this.editor.shiftNext();
        }
        else {
            if (!this.row.idd) {
                return;
            }
            var a = Math.max(c._r_select || 0, this.getRowIndex(this.row.idd));
            var e = this._nextRow(a, 1);
            if (e) {
                c._r_select = null;
                this.selectCell(e, this.cell._cellIndex, true);
                if (c.pagingOn) {
                    c.showRow(e.idd);
                }
            }
            else {
                if (!this.callEvent("onLastRow", [])) {
                    return false;
                }
                this._key_events.k34_0_0.apply(this, []);
                if (this.pagingOn && this.rowsCol[a + 1]) {
                    this.selectCell(a + 1, 0, true);
                }
            }
        }
        this._still_active = true;
    },
    k38_0_0: function () {
        var c = this._realfake ? this._fake : this;
        if (this.editor && this.editor.combo) {
            this.editor.shiftPrev();
        }
        else {
            if (!this.row.idd) {
                return;
            }
            var a = this.getRowIndex(this.row.idd) + 1;
            if (a != -1 && (!this.pagingOn || a != 1)) {
                var e = this._nextRow(a - 1, -1);
                this.selectCell(e, this.cell._cellIndex, true);
                if (c.pagingOn && e) {
                    c.showRow(e.idd);
                }
            }
            else {
                this._key_events.k33_0_0.apply(this, []);
            }
        }
        this._still_active = true;
    }
};
dhtmlXGridObject.prototype._build_master_row = function () {
    var e = document.createElement("DIV");
    var c = ["<table><tr>"];
    for (var a = 0; a < this._cCount; a++) {
        c.push("<td></td>");
    }
    c.push("</tr></table>");
    e.innerHTML = c.join("");
    this._master_row = e.firstChild.rows[0];
};
dhtmlXGridObject.prototype._prepareRow = function (a) {
    if (!this._master_row) {
        this._build_master_row();
    }
    var e = this._master_row.cloneNode(true);
    for (var c = 0; c < e.childNodes.length; c++) {
        e.childNodes[c]._cellIndex = c;
        if (this._enbCid) {
            e.childNodes[c].id = "c_" + a + "_" + c;
        }
        if (this.dragAndDropOff) {
            this.dragger.addDraggableItem(e.childNodes[c], this);
        }
    }
    e.idd = a;
    e.grid = this;
    return e;
};
dhtmlXGridObject.prototype._process_jsarray_row = function (c, e) {
    c._attrs = {};
    for (var a = 0; a < c.childNodes.length; a++) {
        c.childNodes[a]._attrs = {};
    }
    this._fillRow(c, this._c_order ? this._swapColumns(e) : e);
    return c;
};
dhtmlXGridObject.prototype._get_jsarray_data = function (c, a) {
    return c[a];
};
dhtmlXGridObject.prototype._process_json_row = function (a, c) {
    c = this._c_order ? this._swapColumns(c.data) : c.data;
    return this._process_some_row(a, c);
};
dhtmlXGridObject.prototype._process_some_row = function (c, e) {
    c._attrs = {};
    for (var a = 0; a < c.childNodes.length; a++) {
        c.childNodes[a]._attrs = {};
    }
    this._fillRow(c, e);
    return c;
};
dhtmlXGridObject.prototype._get_json_data = function (c, a) {
    return c.data[a];
};
dhtmlXGridObject.prototype._process_js_row = function (e, g) {
    var a = [];
    for (var c = 0; c < this.columnIds.length; c++) {
        a[c] = g[this.columnIds[c]];
        if (!a[c] && a[c] !== 0) {
            a[c] = "";
        }
    }
    this._process_some_row(e, a);
    e._attrs = g;
    return e;
};
dhtmlXGridObject.prototype._get_js_data = function (c, a) {
    return c[this.columnIds[a]];
};
dhtmlXGridObject.prototype._process_csv_row = function (c, e) {
    c._attrs = {};
    for (var a = 0; a < c.childNodes.length; a++) {
        c.childNodes[a]._attrs = {};
    }
    this._fillRow(c, this._c_order
        ? this._swapColumns(e.split(this.csv.cell))
        : e.split(this.csv.cell));
    return c;
};
dhtmlXGridObject.prototype._get_csv_data = function (c, a) {
    return c.split(this.csv.cell)[a];
};
dhtmlXGridObject.prototype._process_store_row = function (h, g) {
    var a = [];
    for (var e = 0; e < this.columnIds.length; e++) {
        a[e] = g[this.columnIds[e]];
    }
    for (var c = 0; c < h.childNodes.length; c++) {
        h.childNodes[c]._attrs = {};
    }
    h._attrs = g;
    this._fillRow(h, a);
};
dhtmlXGridObject.prototype._process_xml_row = function (a, l) {
    var u = dhx4.ajax.xpath(this.xml.cell, l);
    var o = [];
    a._attrs = this._xml_attrs(l);
    if (this._ud_enabled) {
        var s = dhx4.ajax.xpath("./userdata", l);
        for (var h = s.length - 1; h >= 0; h--) {
            var n = "";
            for (var eNum = 0; eNum < s[h].childNodes.length; eNum++) {
                n += s[h].childNodes[eNum].nodeValue;
            }
            this.setUserData(a.idd, s[h].getAttribute("name"), n);
        }
    }
    for (var e = 0; e < u.length; e++) {
        var g = u[this._c_order ? this._c_order[e] : e];
        if (!g) {
            continue;
        }
        var c = a._childIndexes ? a._childIndexes[e] : e;
        var m = g.getAttribute("type");
        if (a.childNodes[c]) {
            if (m) {
                a.childNodes[c]._cellType = m;
            }
            a.childNodes[c]._attrs = this._xml_attrs(g);
        }
        if (!g.getAttribute("xmlcontent")) {
            if (g.firstChild) {
                g = g.firstChild.wholeText || g.firstChild.data;
            }
            else {
                g = "";
            }
        }
        o.push(g);
    }
    for (e < u.length; e < a.childNodes.length; e++) {
        a.childNodes[e]._attrs = {};
    }
    if (a.parentNode && a.parentNode.tagName == "row") {
        a._attrs.parent = a.parentNode.getAttribute("idd");
    }
    this._fillRow(a, o);
    return a;
};
dhtmlXGridObject.prototype._get_xml_data = function (c, a) {
    c = c.firstChild;
    while (true) {
        if (!c) {
            return "";
        }
        if (c.tagName == "cell") {
            a--;
        }
        if (a < 0) {
            break;
        }
        c = c.nextSibling;
    }
    return c.firstChild ? c.firstChild.data : "";
};
dhtmlXGridObject.prototype._fillRow = function (g, l) {
    if (this.editor &&
        this.editor.parentNode &&
        this.editor.parentNode.idd == g.idd) {
        this.editStop();
    }
    for (var c = 0; c < g.childNodes.length; c++) {
        if (c < l.length || this.defVal[c]) {
            var e = g.childNodes[c]._cellIndex;
            var h = l[e];
            var a = this.cells4(g.childNodes[c]);
            if (this.defVal[e] && (h == "" || typeof h == "undefined")) {
                h = this.defVal[e];
            }
            if (a) {
                a.setValue(h);
            }
        }
        else {
            g.childNodes[c].innerHTML = "&nbsp;";
            g.childNodes[c]._clearCell = true;
        }
    }
    return g;
};
dhtmlXGridObject.prototype._postRowProcessing = function (l, n) {
    if (l._attrs["class"]) {
        l._css = l.className = l._attrs["class"];
    }
    if (l._attrs.locked) {
        l._locked = true;
    }
    if (l._attrs.bgColor) {
        l.bgColor = l._attrs.bgColor;
    }
    var m = 0;
    for (var e = 0; e < l.childNodes.length; e++) {
        var o = l.childNodes[e];
        var h = o._cellIndex;
        var g = o._attrs.style || l._attrs.style;
        if (g) {
            o.style.cssText += ";" + g;
        }
        if (o._attrs["class"]) {
            o.className = o._attrs["class"];
        }
        g = o._attrs.align || this.cellAlign[h];
        if (g) {
            o.align = g;
        }
        o.vAlign = o._attrs.valign || this.cellVAlign[h];
        var a = o._attrs.bgColor || this.columnColor[h];
        if (a) {
            o.bgColor = a;
        }
        if (o._attrs.colspan && !n) {
            this.setColspan(l.idd, e + m, o._attrs.colspan);
            m += o._attrs.colspan - 1;
        }
        if (this._hrrar && this._hrrar[h] && !n) {
            o.style.display = "none";
        }
    }
    this.callEvent("onRowCreated", [l.idd, l, null]);
};
dhtmlXGridObject.prototype.load = function (a, e, c) {
    this.callEvent("onXLS", [this]);
    if (arguments.length == 2 && typeof e != "function") {
        c = e;
        e = null;
    }
    c = c || "xml";
    if (!this.xmlFileUrl) {
        this.xmlFileUrl = a;
    }
    this._data_type = c;
    this.xmlLoader = this.doLoadDetails;
    var g = this;
    this.xmlLoader = function (h) {
        if (!g.callEvent) {
            return;
        }
        g["_process_" + c](h.xmlDoc);
        if (!g._contextCallTimer) {
            g.callEvent("onXLE", [g, 0, 0, h.xmlDoc, c]);
        }
        if (e) {
            e();
            e = null;
        }
    };
    return dhx4.ajax.get(a, this.xmlLoader);
};
dhtmlXGridObject.prototype.loadXMLString = function (c, a) {
    if (window.console && window.console.info) {
        window.console.info("loadXMLString was deprecated", "http://docs.dhtmlx.com/migration__index.html#migrationfrom43to44");
    }
    this.parse({ responseXML: dhx4.ajax.parse(c) }, a, "xml");
};
dhtmlXGridObject.prototype.loadXML = function (a, c) {
    if (window.console && window.console.info) {
        window.console.info("loadXML was deprecated", "http://docs.dhtmlx.com/migration__index.html#migrationfrom43to44");
    }
    this.load(a, c, "xml");
};
dhtmlXGridObject.prototype.parse = function (e, c, a) {
    if (arguments.length == 2 && typeof c != "function") {
        a = c;
        c = null;
    }
    a = a || "xml";
    this._data_type = a;
    if (a == "xml" && typeof e == "string") {
        e = { responseXML: dhx4.ajax.parse(e) };
    }
    this["_process_" + a](e);
    if (!this._contextCallTimer) {
        this.callEvent("onXLE", [this, 0, 0, e, a]);
    }
    if (c) {
        c();
    }
};
dhtmlXGridObject.prototype.xml = {
    top: "rows",
    row: "./row",
    cell: "./cell",
    s_row: "row",
    s_cell: "cell",
    row_attrs: [],
    cell_attrs: []
};
dhtmlXGridObject.prototype.csv = { row: "\n", cell: "," };
dhtmlXGridObject.prototype._xml_attrs = function (c) {
    var e = {};
    if (c.attributes.length) {
        for (var a = 0; a < c.attributes.length; a++) {
            e[c.attributes[a].name] = c.attributes[a].value;
        }
    }
    return e;
};
dhtmlXGridObject.prototype._process_xml = function (r) {
    if (this._refresh_mode) {
        return this._refreshFromXML(r);
    }
    this._parsing = true;
    var m = dhx4.ajax.xmltop(this.xml.top, r);
    if (m.tagName != this.xml.top) {
        return;
    }
    var o = m.getAttribute("dhx_security");
    if (o) {
        dhtmlx.security_key = o;
    }
    this._parseHead(m);
    var s = dhx4.ajax.xpath(this.xml.row, m);
    var l = parseInt(m.getAttribute("pos") || 0);
    var n = parseInt(m.getAttribute("total_count") || 0);
    if (!this.pagingOn) {
        n = Math.min(n, 32000000 / this._srdh);
    }
    var g = false;
    if (n && n != this.rowsBuffer.length) {
        if (!this.rowsBuffer[n - 1]) {
            if (this.rowsBuffer.length) {
                g = true;
            }
            this.rowsBuffer[n - 1] = null;
        }
        if (n < this.rowsBuffer.length) {
            this.rowsBuffer.splice(n, this.rowsBuffer.length - n);
            g = true;
        }
    }
    if (this.isTreeGrid()) {
        return this._process_tree_xml(m);
    }
    for (var c = 0; c < s.length; c++) {
        if (this.rowsBuffer[c + l]) {
            continue;
        }
        var a = s[c].getAttribute("id") || c + l + 1;
        this.rowsBuffer[c + l] = {
            idd: a,
            data: s[c],
            _parser: this._process_xml_row,
            _locator: this._get_xml_data
        };
        this.rowsAr[a] = s[c];
    }
    this.callEvent("onDataReady", []);
    if (g && this._srnd) {
        var e = this.objBox.scrollTop;
        this._reset_view();
        this.objBox.scrollTop = e;
    }
    else {
        this.render_dataset();
    }
    this._parsing = false;
};
dhtmlXGridObject.prototype._process_jsarray = function (data) {
    this._parsing = true;
    data = data.responseText || data;
    if (typeof data == "string") {
        eval("dhtmlx.temp=" + data + ";");
        data = dhtmlx.temp;
    }
    for (var i = 0; i < data.length; i++) {
        var id = i + 1;
        this.rowsBuffer.push({
            idd: id,
            data: data[i],
            _parser: this._process_jsarray_row,
            _locator: this._get_jsarray_data
        });
        this.rowsAr[id] = data[i];
    }
    this.render_dataset();
    this._parsing = false;
};
dhtmlXGridObject.prototype._process_csv = function (g) {
    this._parsing = true;
    g = g.responseText || g;
    g = g.replace(/\r/g, "");
    g = g.split(this.csv.row);
    if (this._csvHdr) {
        this.clearAll();
        var e = g.splice(0, 1)[0].split(this.csv.cell);
        if (!this._csvAID) {
            e.splice(0, 1);
        }
        this.setHeader(e.join(this.delim));
        this.init();
    }
    for (var c = 0; c < g.length; c++) {
        var h = null;
        if (!g[c] && c == g.length - 1) {
            continue;
        }
        if (this._csvAID) {
            h = c + 1;
            this.rowsBuffer.push({
                idd: h,
                data: g[c],
                _parser: this._process_csv_row,
                _locator: this._get_csv_data
            });
        }
        else {
            var a = g[c].split(this.csv.cell);
            h = a.splice(0, 1)[0];
            this.rowsBuffer.push({
                idd: h,
                data: a,
                _parser: this._process_jsarray_row,
                _locator: this._get_jsarray_data
            });
        }
        this.rowsAr[h] = g[c];
    }
    this.render_dataset();
    this._parsing = false;
};
dhtmlXGridObject.prototype._process_js = function (a) {
    return this._process_json(a, "js");
};
dhtmlXGridObject.prototype._process_json = function (data, mode) {
    this._parsing = true;
    var id = null;
    data = data.responseText || data;
    if (typeof data == "string") {
        eval("dhtmlx.temp=" + data + ";");
        data = dhtmlx.temp;
    }
    if (mode == "js") {
        if (data.data) {
            data = data.data;
        }
        for (var i = 0; i < data.length; i++) {
            var row = data[i];
            id = row.id || i + 1;
            this.rowsBuffer.push({
                idd: id,
                data: row,
                _parser: this._process_js_row,
                _locator: this._get_js_data
            });
            this.rowsAr[id] = data[i];
        }
    }
    else {
        if (data.rows) {
            for (var i_1 = 0; i_1 < data.rows.length; i_1++) {
                id = data.rows[i_1].id;
                this.rowsBuffer.push({
                    idd: id,
                    data: data.rows[i_1],
                    _parser: this._process_json_row,
                    _locator: this._get_json_data
                });
                this.rowsAr[id] = data.rows[i_1];
            }
        }
    }
    if (data.dhx_security) {
        dhtmlx.security_key = data.dhx_security;
    }
    this.callEvent("onDataReady", []);
    this.render_dataset();
    this._parsing = false;
};
dhtmlXGridObject.prototype.render_dataset = function (g, o) {
    if (this._srnd) {
        if (this._fillers) {
            return this._update_srnd_view();
        }
        o = Math.min(this._get_view_size() + (this._srnd_pr || 0), this.rowsBuffer.length);
    }
    if (this.pagingOn) {
        g = Math.max(g || 0, (this.currentPage - 1) * this.rowsBufferOutSize);
        o = Math.min(this.currentPage * this.rowsBufferOutSize, this.rowsBuffer.length);
    }
    else {
        g = g || 0;
        o = o || this.rowsBuffer.length;
    }
    for (var h = g; h < o; h++) {
        var a = this.render_row(h);
        if (a == -1) {
            if (this.xmlFileUrl) {
                if (this.callEvent("onDynXLS", [h, this._dpref ? this._dpref : o - h])) {
                    this.load(this.xmlFileUrl +
                        dhtmlx.url(this.xmlFileUrl) +
                        "posStart=" +
                        h +
                        "&count=" +
                        (this._dpref ? this._dpref : o - h), this._data_type);
                }
            }
            o = h;
            break;
        }
        if (!a.parentNode || !a.parentNode.tagName) {
            this._insertRowAt(a, h);
            if (a._attrs.selected || a._attrs.select) {
                this.selectRow(a, a._attrs.call ? true : false, true);
                a._attrs.selected = a._attrs.select = null;
            }
        }
        if (this._ads_count && h - g == this._ads_count) {
            var n = this;
            this._context_parsing = this._context_parsing || this._parsing;
            return (this._contextCallTimer = window.setTimeout(function () {
                n._contextCallTimer = null;
                n.render_dataset(h, o);
                if (!n._contextCallTimer) {
                    if (n._context_parsing) {
                        n.callEvent("onXLE", []);
                    }
                    else {
                        n._fixAlterCss();
                    }
                    n._context_parsing = false;
                }
            }, this._ads_time));
        }
    }
    if (this._ads_count && h == o) {
        this.callEvent("onDistributedEnd", []);
    }
    if (this._srnd && !this._fillers) {
        var c = this.rowsBuffer.length - o;
        this._fillers = [];
        if (this._fake && !this._realfake) {
            this._fake._fillers = [];
        }
        var e = Math.round(990000 / this._srdh);
        while (c > 0) {
            var l = dhx4.isIE || window._FFrv ? Math.min(c, e) : c;
            var m = this._add_filler(o, l);
            if (m) {
                this._fillers.push(m);
            }
            c -= l;
            o += l;
        }
    }
    this.setSizes();
};
dhtmlXGridObject.prototype.render_row = function (c) {
    if (!this.rowsBuffer[c]) {
        return -1;
    }
    if (this.rowsBuffer[c]._parser) {
        var a = this.rowsBuffer[c];
        if (this.rowsAr[a.idd] && this.rowsAr[a.idd].tagName == "TR") {
            return (this.rowsBuffer[c] = this.rowsAr[a.idd]);
        }
        var e = this._prepareRow(a.idd);
        this.rowsBuffer[c] = e;
        this.rowsAr[a.idd] = e;
        a._parser.call(this, e, a.data);
        this._postRowProcessing(e);
        return e;
    }
    return this.rowsBuffer[c];
};
dhtmlXGridObject.prototype._get_cell_value = function (c, a, e) {
    if (c._locator) {
        if (this._c_order) {
            a = this._c_order[a];
        }
        return c._locator.call(this, c.data, a);
    }
    return this.cells3(c, a)[e ? e : "getValue"]();
};
dhtmlXGridObject.prototype.sortRows = function (e, l, c) {
    this.editStop();
    c = (c || "asc").toLowerCase();
    l = l || this.fldSort[e];
    e = e || 0;
    if (this.isTreeGrid()) {
        this.sortTreeRows(e, l, c);
    }
    else {
        var a = {};
        var h = this.cellType[e];
        var m = "getValue";
        if (h == "link") {
            m = "getContent";
        }
        if (h == "dhxCalendar" || h == "dhxCalendarA") {
            m = "getDate";
        }
        for (var g = 0; g < this.rowsBuffer.length; g++) {
            a[this.rowsBuffer[g].idd] = this._get_cell_value(this.rowsBuffer[g], e, m);
        }
        this._sortRows(e, l, c, a);
    }
    this.callEvent("onAfterSorting", [e, l, c]);
};
dhtmlXGridObject.prototype._sortCore = function (e, l, c, a, h) {
    var g = "sort";
    if (this._sst) {
        h.stablesort = this.rowsCol.stablesort;
        g = "stablesort";
    }
    if (l.length > 4) {
        l = window[l];
    }
    if (l == "cus") {
        var m = this._customSorts[e];
        h[g](function (o, n) {
            return m(a[o.idd], a[n.idd], c, o.idd, n.idd);
        });
    }
    else {
        if (typeof l == "function") {
            h[g](function (o, n) {
                return l(a[o.idd], a[n.idd], c, o.idd, n.idd);
            });
        }
        else {
            if (l == "str") {
                h[g](function (o, n) {
                    if (c == "asc") {
                        return a[o.idd] > a[n.idd] ? 1 : a[o.idd] < a[n.idd] ? -1 : 0;
                    }
                    else {
                        return a[o.idd] < a[n.idd] ? 1 : a[o.idd] > a[n.idd] ? -1 : 0;
                    }
                });
            }
            else {
                if (l == "int") {
                    h[g](function (r, o) {
                        var n = parseFloat(a[r.idd]);
                        n = isNaN(n) ? -99999999999999 : n;
                        var s = parseFloat(a[o.idd]);
                        s = isNaN(s) ? -99999999999999 : s;
                        if (c == "asc") {
                            return n - s;
                        }
                        else {
                            return s - n;
                        }
                    });
                }
                else {
                    if (l == "date") {
                        h[g](function (r, o) {
                            var n = Date.parse(a[r.idd]) || Date.parse("01/01/1900");
                            var s = Date.parse(a[o.idd]) || Date.parse("01/01/1900");
                            if (c == "asc") {
                                return n - s;
                            }
                            else {
                                return s - n;
                            }
                        });
                    }
                }
            }
        }
    }
};
dhtmlXGridObject.prototype._sortRows = function (e, g, c, a) {
    this._sortCore(e, g, c, a, this.rowsBuffer);
    this._reset_view();
    this.callEvent("onGridReconstructed", []);
};
dhtmlXGridObject.prototype._reset_view = function (e) {
    if (!this.obj.rows[0]) {
        return;
    }
    if (this._lahRw) {
        this._unsetRowHover(0, true);
    }
    this.callEvent("onResetView", []);
    var a = this.obj.rows[0].parentNode;
    var g = a.removeChild(a.childNodes[0], true);
    if (window._isKHTML) {
        for (var c = a.parentNode.childNodes.length - 1; c >= 0; c--) {
            if (a.parentNode.childNodes[c].tagName == "TR") {
                a.parentNode.removeChild(a.parentNode.childNodes[c], true);
            }
        }
    }
    else {
        if (dhx4.isIE) {
            for (var c_1 = a.childNodes.length - 1; c_1 >= 0; c_1--) {
                a.childNodes[c_1].removeNode(true);
            }
        }
        else {
            a.innerHTML = "";
        }
    }
    a.appendChild(g);
    this.rowsCol = new dhtmlxArray();
    if (this._sst) {
        this.enableStableSorting(true);
    }
    this._fillers = this.undefined;
    if (!e) {
        if (dhx4.isIE && this._srnd) {
            this.render_dataset();
        }
        else {
            this.render_dataset();
        }
    }
};
dhtmlXGridObject.prototype.deleteRow = function (c, g) {
    if (!g) {
        g = this.getRowById(c);
    }
    if (!g) {
        return;
    }
    this.editStop();
    if (!this._realfake) {
        if (this.callEvent("onBeforeRowDeleted", [c]) == false) {
            return false;
        }
    }
    var a = 0;
    if (this.cellType._dhx_find("tree") != -1 && !this._realfake) {
        a = this._h2.get[c].parent.id;
        this._removeTrGrRow(g);
    }
    else {
        if (g.parentNode) {
            g.parentNode.removeChild(g);
        }
        var l = this.rowsCol._dhx_find(g);
        if (l != -1) {
            this.rowsCol._dhx_removeAt(l);
        }
        for (var e = 0; e < this.rowsBuffer.length; e++) {
            if (this.rowsBuffer[e] && this.rowsBuffer[e].idd == c) {
                this.rowsBuffer._dhx_removeAt(e);
                l = e;
                break;
            }
        }
    }
    this.rowsAr[c] = null;
    for (var e_4 = 0; e_4 < this.selectedRows.length; e_4++) {
        if (this.selectedRows[e_4].idd == c) {
            this.selectedRows._dhx_removeAt(e_4);
        }
    }
    if (this._srnd) {
        for (var e_5 = 0; e_5 < this._fillers.length; e_5++) {
            var h = this._fillers[e_5];
            if (!h) {
                continue;
            }
            if (h[0] >= l) {
                this._update_fillers(e_5, 0, -1);
            }
            else {
                if (h[0] + h[1] > l) {
                    this._update_fillers(e_5, -1, 0);
                }
            }
        }
        this._update_srnd_view();
    }
    if (this.pagingOn) {
        this.changePage();
    }
    if (!this._realfake) {
        this.callEvent("onAfterRowDeleted", [c, a]);
    }
    this.callEvent("onGridReconstructed", []);
    if (this._ahgr) {
        this.setSizes();
    }
    return true;
};
dhtmlXGridObject.prototype._addRow = function (l, m, c) {
    if (c == -1 || typeof c == "undefined") {
        c = this.rowsBuffer.length;
    }
    if (typeof m == "string") {
        m = m.split(this.delim);
    }
    var n = this._prepareRow(l);
    n._attrs = {};
    for (var e = 0; e < n.childNodes.length; e++) {
        n.childNodes[e]._attrs = {};
    }
    this.rowsAr[n.idd] = n;
    if (this._h2) {
        this._h2.get[n.idd].buff = n;
    }
    this._fillRow(n, m);
    this._postRowProcessing(n);
    if (this._skipInsert) {
        this._skipInsert = false;
        return (this.rowsAr[n.idd] = n);
    }
    if (this.pagingOn) {
        this.rowsBuffer._dhx_insertAt(c, n);
        this.rowsAr[n.idd] = n;
        return n;
    }
    if (this._fillers) {
        this.rowsCol._dhx_insertAt(c, null);
        this.rowsBuffer._dhx_insertAt(c, n);
        if (this._fake) {
            this._fake.rowsCol._dhx_insertAt(c, null);
        }
        this.rowsAr[n.idd] = n;
        var o = false;
        for (var g = 0; g < this._fillers.length; g++) {
            var h = this._fillers[g];
            if (h && h[0] <= c && h[0] + h[1] >= c) {
                h[1] = h[1] + 1;
                var a = (h[2].firstChild.style.height =
                    parseInt(h[2].firstChild.style.height) + this._srdh + "px");
                o = true;
                if (this._fake) {
                    this._fake._fillers[g][1]++;
                    this._fake._fillers[g][2].firstChild.style.height = a;
                }
            }
            if (h && h[0] > c) {
                h[0] = h[0] + 1;
                if (this._fake) {
                    this._fake._fillers[g][0]++;
                }
            }
        }
        if (!o) {
            this._fillers.push(this._add_filler(c, 1, c == 0
                ? {
                    parentNode: this.obj.rows[0].parentNode,
                    nextSibling: this.rowsCol[1]
                }
                : this.rowsCol[c - 1]));
        }
        return n;
    }
    this.rowsBuffer._dhx_insertAt(c, n);
    return this._insertRowAt(n, c);
};
dhtmlXGridObject.prototype._addRowClassic = function (a, g, e) {
    var c = this._addRow(a, g, e);
    if (!this.dragContext) {
        this.callEvent("onRowAdded", [a]);
    }
    if (this.pagingOn) {
        this.changePage(this.currentPage);
    }
    if (this._srnd) {
        this._update_srnd_view();
    }
    c._added = true;
    if (this._srnd && !this._fillers) {
        this._fillers = [];
    }
    if (this._ahgr) {
        this.setSizes();
    }
    this.callEvent("onGridReconstructed", []);
    return c;
};
dhtmlXGridObject.prototype._insertRowAt = function (e, g, c) {
    this.rowsAr[e.idd] = e;
    if (this._skipInsert) {
        this._skipInsert = false;
        return e;
    }
    if (g < 0 || (!g && parseInt(g) !== 0)) {
        g = this.rowsCol.length;
    }
    else {
        if (g > this.rowsCol.length) {
            g = this.rowsCol.length;
        }
    }
    if (this._cssEven) {
        var a = e.className.replace(this._cssUnEven, "");
        if ((this._cssSP ? this.getLevel(e.idd) : g) % 2 == 1) {
            e.className =
                a +
                    " " +
                    this._cssUnEven +
                    (this._cssSU ? " " + this._cssUnEven + "_" + this.getLevel(e.idd) : "");
        }
        else {
            e.className =
                a +
                    " " +
                    this._cssEven +
                    (this._cssSU ? " " + this._cssEven + "_" + this.getLevel(e.idd) : "");
        }
    }
    if (!c) {
        if (g == this.obj.rows.length - 1 || !this.rowsCol[g]) {
            if (window._isKHTML) {
                this.obj.appendChild(e);
            }
            else {
                this.obj.firstChild.appendChild(e);
            }
        }
        else {
            this.rowsCol[g].parentNode.insertBefore(e, this.rowsCol[g]);
        }
    }
    this.rowsCol._dhx_insertAt(g, e);
    this.callEvent("onRowInserted", [e, g]);
    return e;
};
dhtmlXGridObject.prototype.getRowById = function (e) {
    var c = this.rowsAr[e];
    if (c) {
        if (c.tagName != "TR") {
            for (var a = 0; a < this.rowsBuffer.length; a++) {
                if (this.rowsBuffer[a] && this.rowsBuffer[a].idd == e) {
                    return this.render_row(a);
                }
            }
            if (this._h2) {
                return this.render_row(null, c.idd);
            }
        }
        return c;
    }
    return null;
};
dhtmlXGridObject.prototype.cellById = function (c, a) {
    return this.cells(c, a);
};
dhtmlXGridObject.prototype.cells = function (g, e) {
    if (arguments.length == 0) {
        return this.cells4(this.cell);
    }
    else {
        var h = this.getRowById(g);
    }
    var a = h._childIndexes ? h.childNodes[h._childIndexes[e]] : h.childNodes[e];
    if (!a && h._childIndexes) {
        a = h.firstChild || {};
    }
    return this.cells4(a);
};
dhtmlXGridObject.prototype.cellByIndex = function (c, a) {
    return this.cells2(c, a);
};
dhtmlXGridObject.prototype.cells2 = function (g, e) {
    var h = this.render_row(g);
    var a = h._childIndexes ? h.childNodes[h._childIndexes[e]] : h.childNodes[e];
    if (!a && h._childIndexes) {
        a = h.firstChild || {};
    }
    return this.cells4(a);
};
dhtmlXGridObject.prototype.cells3 = function (e, c) {
    var a = e._childIndexes ? e.childNodes[e._childIndexes[c]] : e.childNodes[c];
    return this.cells4(a);
};
dhtmlXGridObject.prototype.cells4 = function (a) {
    var c = window["eXcell_" + (a._cellType || this.cellType[a._cellIndex])];
    if (c) {
        return new c(a);
    }
};
dhtmlXGridObject.prototype.cells5 = function (a, e) {
    var eObj = e || (a._cellType || this.cellType[a._cellIndex]);
    var c = null;
    if (!this._ecache[eObj]) {
        if (!window["eXcell_" + eObj]) {
            c = eXcell_ro;
        }
        else {
            c = window["eXcell_" + eObj];
        }
        this._ecache[eObj] = new c(a);
    }
    this._ecache[eObj].cell = a;
    return this._ecache[eObj];
};
dhtmlXGridObject.prototype.dma = function (a) {
    if (!this._ecache) {
        this._ecache = {};
    }
    if (a && !this._dma) {
        this._dma = this.cells4;
        this.cells4 = this.cells5;
    }
    else {
        if (!a && this._dma) {
            this.cells4 = this._dma;
            this._dma = null;
        }
    }
};
dhtmlXGridObject.prototype.getRowsNum = function () {
    return this.rowsBuffer.length;
};
dhtmlXGridObject.prototype.enableEditTabOnly = function (a) {
    if (arguments.length > 0) {
        this.smartTabOrder = dhx4.s2b(a);
    }
    else {
        this.smartTabOrder = true;
    }
};
dhtmlXGridObject.prototype.setExternalTabOrder = function (h, a) {
    var c = this;
    this.tabStart = typeof h == "object" ? h : document.getElementById(h);
    var e = this.tabStart.onkeydown;
    this.tabStart.onkeydown = function (m) {
        if (e) {
            e.call(this, m);
        }
        var l = m || window.event;
        if (l.keyCode == 9 && !l.shiftKey) {
            l.cancelBubble = true;
            c.selectCell(0, 0, 0, 0, 1);
            if (c.smartTabOrder && c.cells2(0, 0).isDisabled()) {
                c._key_events.k9_0_0.call(c);
            }
            this.blur();
            return false;
        }
    };
    if (dhx4.isOpera) {
        this.tabStart.onkeypress = this.tabStart.onkeydown;
    }
    this.tabEnd = typeof a == "object" ? a : document.getElementById(a);
    var g = this.tabEnd.onkeydown;
    this.tabEnd.onkeydown = this.tabEnd.onkeypress = function (m) {
        if (g) {
            g.call(this, m);
        }
        var l = m || window.event;
        if (l.keyCode == 9 && l.shiftKey) {
            l.cancelBubble = true;
            c.selectCell(c.getRowsNum() - 1, c.getColumnCount() - 1, 0, 0, 1);
            if (c.smartTabOrder &&
                c.cells2(c.getRowsNum() - 1, c.getColumnCount() - 1).isDisabled()) {
                c._key_events.k9_0_1.call(c);
            }
            this.blur();
            return false;
        }
    };
    if (dhx4.isOpera) {
        this.tabEnd.onkeypress = this.tabEnd.onkeydown;
    }
};
dhtmlXGridObject.prototype.setIconset = function (a) {
    this.iconset = a;
};
dhtmlXGridObject.prototype.clearAndLoad = function () {
    if (this._last_load_request) {
        var c = this._last_load_request.xmlDoc;
        if (c.readyState != 4) {
            try {
                c.onreadystatechange = function () { };
                c.abort();
            }
            catch (g) { }
        }
    }
    var a = this._pgn_skin;
    this._pgn_skin = null;
    this.clearAll();
    this._pgn_skin = a;
    this._last_load_request = this.load.apply(this, arguments);
};
dhtmlXGridObject.prototype.getStateOfView = function () {
    if (this.pagingOn) {
        var a = (this.currentPage - 1) * this.rowsBufferOutSize;
        return [
            this.currentPage,
            a,
            Math.min(a + this.rowsBufferOutSize, this.rowsBuffer.length),
            this.rowsBuffer.length
        ];
    }
    return [
        Math.floor(this.objBox.scrollTop / this._srdh),
        Math.ceil(parseInt(this.objBox.offsetHeight) / this._srdh),
        this.rowsBuffer.length
    ];
};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dXGridObject/dxGridMethods0000.js